import { CodedError } from '../CodedError';
import { errorCodeTypes } from './errorCodeTypes';

export class AddTenantLeaseError extends CodedError {
  static get errorName() {
    return errorCodeTypes.addTenantLeaseError.code;
  }

  constructor(message = errorCodeTypes.addTenantLeaseError.message) {
    super(message);
    this.code = errorCodeTypes.addTenantLeaseError.code;
    this.message = `${message} ${errorCodeTypes.addTenantLeaseError.code}`;
    this.name = errorCodeTypes.addTenantLeaseError.name;
  }
}
